// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import bootstrap from 'bootstrap/dist/css/bootstrap.css'
import icons from 'bootstrap-icons/font/bootstrap-icons.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Vue2TouchEvents from 'vue2-touch-events'
import store from './store'
import utils from './utilities'
// eslint-disable-next-line
import '@/styles.scss'
// eslint-disable-next-line
import cutterfont from '@/generated/cutterkollegen.css'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import PullToRefresh from 'pulltorefreshjs'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vue2TouchEvents)

// make a date formatter
Vue.filter('formatDate', function (value) {
  const options = {
    dateStyle: 'short',
    timeStyle: 'short'
  }
  if (value) {
    return new Intl.DateTimeFormat('de-DE', options).format(new Date(value.substring(0, value.length - 5)))
  }
})
// make a date formatter
Vue.filter('formatDateOnly', function (value) {
  const options = {
    dateStyle: 'short'
  }
  if (value) {
    return new Intl.DateTimeFormat('de-DE', options).format(new Date(value.substring(0, value.length - 5)))
  }
})
// make a number formatter
Vue.filter('number', function (value) {
  if (value) {
    return value.toLocaleString('de-DE')
  }
  return 0
})

Vue.filter('actionText', function (value) {
  return utils.actionText(value)
})
Vue.filter('statusText', function (value) {
  return utils.statusText(value)
})

PullToRefresh.init({
  mainElement: 'body',
  onRefresh () {
    window.location.reload()
  }
})

// allow events to bubble up
Vue.use((Vue) => {
  Vue.prototype.$bubble = function $bubble (eventName, ...args) {
    // Emit the event on all parent components
    let component = this
    do {
      component.$emit(eventName, ...args)
      component = component.$parent
    } while (component)
  }
})

// eslint-disable-next-line
let vue = new Vue({
  el: '#app',
  store,
  router,
  components: {App, router, store, icons},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main/vue/main.js